<template>
  <modal
      id="shop-list-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Product')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        method="post"
        enctype="multipart/form-data"
        :data-url='selectedUrl ? selectedUrl : SHOP_HOME'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :label="$t('title')"
              v-model="formData.title"
              :error-message="$errorMessage(errors, 'title')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="input-area">
            <div class="d-flex flex-column mb-2">
              <label id="upload-label" for="upload">{{ $t('Product Image') }}</label>
              <small class="text-muted font-italic">(Recommended size: 370 x 90 px)</small>
            </div>
            <input id="upload"
                   @change="uploadImage"
                   type="file"
                   required
                   name="product_image"
                   ref="changeProfileImage"
                   class="form-control">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              :custom-input="true"
              :label="$t('Product Tags')"
              v-model="tags"
              :data="{ id: 'tags' }"
          />
<!--          <div class="input-area">
            <div class="d-flex flex-column mb-2">
              <label id="tags" for="tags">{{ $t('Product Tags') }}</label>
            </div>
            <app-custom-tag-input :id="'tags'" @update-tags="handleTagsUpdate" :tags="tags"/>
          </div>-->
        </div>
      </div>
      <div class="row mt-4">

        <div class="col-md-12">
          <app-input
              type="text-editor"
              v-model="formData.description"
              v-if="!loading"
              id="description"
              required
              :placeholder="$textAreaPlaceHolder('description')"
              row="5"
              :error-message="$errorMessage(errors, 'custom_content')"
          />
          <span class="text-danger">{{ $errorMessage(errors, 'description') }}</span>
        </div>
        <div class="col-md-12 mt-4">
          <div class="row">
            <div class="col-md-6">
              <app-form-group
                  type="number"
                  :label="$t('price')"
                  v-model="formData.price"
                  :error-message="$errorMessage(errors, 'price')"
              />
            </div>
            <div class="col-md-6">
              <app-form-group
                  type="number"
                  :label="$t('quantity')"
                  v-model="formData.stock"
                  :error-message="$errorMessage(errors, 'stock')"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              :label="$t('status')"
              type="radio"
              :list="[
                {id:'available',value: $t('status_available')},
                {id:'unavailable', value:  $t('status_unavailable')},
            ]"
              v-model="formData.status"
              :error-message="$errorMessage(errors, 'status')"
          />
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  SHOP_HOME,
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";
import {InputMixin} from "../../../../core/components/input/mixin/InputMixin";
import _ from "lodash";
import {kebabCase} from "../../../../common/Helper/Support/TextHelper";
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  name: "ShopCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins, InputMixin],
  components: {
    VueTagsInput
  },
  props: {
    from: {
      type: String,
      default: 'shop'
    },
    recommendation: {
      type: String,
      default: ''
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      textEditorHints,
      maps: null,
      imageUploaderBoot: false,
      tags: [],
      image: {
        product_image: null
      },
      // 'multi_day', 'single_day', 'last_half', 'hours', 'first_half'
      leaveTypes: [
        // { id: 'short_leave', label: 'Short Leave' },
        // { id: 'paid_leave', label: 'Paid Leave' },
        // { id: 'casual_leave', label: 'Casual Leave' }
      ],
      duration_type_list: [
        {id: 'single_day', label: 'Single day'},
        {id: 'multi_day', label: 'Multi day'},
        {id: 'first_half', label: 'First half'},
        {id: 'last_half', label: 'Last half'},
        {id: 'hours', label: 'Hours'},
      ],
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      formData: {
        title: "",
        price: 0.0,
        description: "",
        image: "",
        status: "",
        stock: 0,
        leave_type: "reward_leave",
        duration: 1,
        duration_type: "",
        tags: [],
      },
      SHOP_HOME,
    }
  },
  methods: {
    handleTagsUpdate(tags) {
      this.tags = tags;
    },
    async fetchLeaveTypes() {
      try {
        const response = await axios.get('/admin/leave/leave-types');
        this.leaveTypes = response.data;
        // this.formData.leave_type = this.leaveTypes[0].id;
      } catch (error) {
        console.error('Error fetching leave types:', error);
      }
    },
    async uploadImage(event) {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('product_image', file);

      try {
        const response = await axios.post('/admin/shop/product/image', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.formData.image = response.data.url;
      } catch (error) {
        console.error("There was an error uploading the image", error);
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.formData.image = URL.createObjectURL(file);
        console.log("Image path:", this.formData.image);
      }
    },
    readURL(event) {
      const files = event.target.files;
      console.log(files);
      if (files && files[0]) {

        let formData = new FormData();

        formData.append('product_image', files[0]);
        formData.append('user_id', 14);

        for (let pair of formData.entries()) {
          console.log(pair[0] + ', ' + pair[1]);
        }

        axiosPost(`admin/shop/product/image`, formData).then(response => {
          console.log(response);
          // this.$store.dispatch("getEmployeeDetails", this.employeeId);
          this.$toastr.s(response.data ? response.data.message : '');
        }).catch(error => {
          console.log(error.response.data);
          // this.$store.dispatch("getEmployeeDetails", this.employeeId);
          this.$toastr.e(error.response.data ? error.response.data.errors.product_image[0] : '');
        });

      }
    },
    propsFor() {
      let props = this.$attrs;
      const cTor = this.$options.components['app-input']
      if (cTor) {
        let keys = Object.keys(cTor.options.props)
        return _.pick(props, keys.map(key => {
          return kebabCase(key)
        }))
      }
    },
    submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      this.formData.tags = JSON.stringify(this.tags);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#shop-list-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'shop' ? 'shop-table' : 'user-table');
      if (this.from === 'shop') {
        this.$hub.$emit(`reload-shop-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      //Before customization this was "  this.formData = data;"
      this.tags = JSON.parse(data.tags);
      this.formData = {...this.formData, ...data};
      this.formData.tags = JSON.parse(data.tags);
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
    this.fetchLeaveTypes();
    this.formData.duration_type = this.duration_type_list[0].id;
  },
  computed: {
    fileLabel() {
      if (this.value && this.fieldValue && this.fieldValue === this.value)
        return this.value?.name ? this.value.name : this.data.label;
      else return this.data.label;
    }
  },
  mounted() {
  },
  watch: {},
}
</script>